import React from 'react';
import cx from 'classnames';
import mask from './image/mask.png.js';
import styles from './index.module.scss.js';

const GradientWrapper = ({ fullWidth = true, className, style, children, ...props }) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...props,
    className: cx(styles.box, className, {
      [styles.full]: fullWidth
    }),
    style
  },
  /* @__PURE__ */ React.createElement("img", { className: styles.mask, src: mask, alt: "mask" }),
  children
);
GradientWrapper.displayName = "GradientWrapper";

export { GradientWrapper };
//# sourceMappingURL=index.js.map
